import { createActions } from "reduxsauce";

export const ACTIVE_MEMBERSHIP_STORAGE_KEY = "activeMembershipId";

const { Types, Creators } = createActions({
  defMembershipRequest: [],
  defMembershipSuccess: ["defMembership", "membershipAccounts"],
  defMembershipFailure: ["error"],
  defMembershipResetSuccess: null,
  resetDefMembership: [],
  switchMembershipRequest: ["membershipId"],
  switchMembershipSuccess: ["defMembership", "membershipAccounts"],
  switchMembershipFailure: ["error"],
  setDefaultMembershipRequest: ["membershipId"],
  setDefaultMembershipSuccess: ["defMembership", "membershipAccounts"],
  setDefaultMembershipFailure: ["error"],
});

export const DefMembersipTypes = Types;
export default Creators;
